import type { INetworkMetadata } from '../types.js'

export const networks: INetworkMetadata[] = [
  {
    "id": "zksync",
    "filePath": "network:zksync",
    "chainId": 324,
    "caip2id": "eip155:324",
    "name": "zkSync era",
    "shortName": "zkSync",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "thundercore",
    "filePath": "network:thundercore",
    "chainId": 108,
    "caip2id": "eip155:108",
    "name": "ThunderCore",
    "shortName": "thunder",
    "nativeCoinId": "thunder-token",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "theta",
    "filePath": "network:theta",
    "chainId": 361,
    "caip2id": "eip155:361",
    "name": "Theta",
    "shortName": "theta",
    "nativeCoinId": "theta-token",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "meter",
    "filePath": "network:meter",
    "chainId": 82,
    "caip2id": "eip155:82",
    "name": "Meter",
    "shortName": "meter",
    "nativeCoinId": "meter",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "fuse",
    "filePath": "network:fuse",
    "chainId": 122,
    "caip2id": "eip155:122",
    "name": "Fuse",
    "shortName": "fuse",
    "nativeCoinId": "fuse-network-token",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "near-protocol",
    "filePath": "network:near-protocol",
    "chainId": 39,
    "caip2id": "near:mainnet",
    "name": "Near Protocol",
    "shortName": "near-protocol",
    "nativeCoinId": "near",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "enuls",
    "filePath": "network:enuls",
    "chainId": 119,
    "caip2id": "eip155:119",
    "name": "enuls",
    "shortName": "enuls",
    "nativeCoinId": "nuls",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "aurora",
    "filePath": "network:aurora",
    "chainId": 1313161554,
    "caip2id": "eip155:1313161554",
    "name": "Aurora",
    "shortName": "aurora",
    "nativeCoinId": "aurora-near",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "polygon",
    "filePath": "network:polygon",
    "chainId": 137,
    "caip2id": "eip155:137",
    "name": "Polygon",
    "shortName": "MATIC",
    "nativeCoinId": "matic-network",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "multiversx",
    "filePath": "network:multiversx",
    "name": "MultiversX",
    "shortName": "multiversx",
    "nativeCoinId": "egld",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "tombchain",
    "filePath": "network:tombchain",
    "chainId": 6969,
    "caip2id": "eip155:6969",
    "name": "Tombchain",
    "shortName": "tomb",
    "nativeCoinId": "tomb",
    "variants": [
      "background",
      "branded"
    ]
  },
  {
    "id": "l3x",
    "filePath": "network:l3x",
    "chainId": 12324,
    "caip2id": "eip155:12324",
    "name": "L3X Protocol",
    "shortName": "l3x",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "fraxtal",
    "filePath": "network:fraxtal",
    "chainId": 252,
    "caip2id": "eip155:252",
    "name": "Fraxtal",
    "shortName": "fraxtal",
    "nativeCoinId": "fraxtal",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ethereum",
    "filePath": "network:ethereum",
    "chainId": 1,
    "caip2id": "eip155:1",
    "name": "Ethereum",
    "shortName": "Ethereum",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "holesky",
    "filePath": "network:ethereum",
    "chainId": 17000,
    "caip2id": "eip155:17000",
    "name": "Holesky Testnet",
    "shortName": "Holesky",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "goerli",
    "filePath": "network:ethereum",
    "chainId": 5,
    "caip2id": "eip155:5",
    "name": "Goerli Testnet",
    "shortName": "Goerli",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "neon-evm",
    "filePath": "network:neon-evm",
    "chainId": 245022934,
    "caip2id": "eip155:245022934",
    "name": "Neon EVM",
    "shortName": "neon-evm",
    "nativeCoinId": "neon",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "mint",
    "filePath": "network:mint",
    "chainId": 185,
    "caip2id": "eip155:185",
    "name": "Mint",
    "shortName": "mint",
    "nativeCoinId": "weth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "zyx",
    "filePath": "network:zyx",
    "chainId": 55,
    "caip2id": "eip155:55",
    "name": "zyx",
    "shortName": "zyx",
    "nativeCoinId": "zyx",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "cronos-zkevm",
    "filePath": "network:cronos-zkevm",
    "chainId": 388,
    "caip2id": "eip155:388",
    "name": "Cronos zkEVM",
    "shortName": "cronos",
    "nativeCoinId": "cronos-zkevm-cro",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "apex-layer",
    "filePath": "network:apex-layer",
    "chainId": 2662,
    "caip2id": "eip155:2662",
    "name": "apex layer",
    "shortName": "apex",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "lava-network",
    "filePath": "network:lava-network",
    "name": "lava-network",
    "shortName": "lava",
    "nativeCoinId": "lava-network",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "cosmos-hub",
    "filePath": "network:cosmos-hub",
    "caip2id": "cosmos:cosmoshub-4",
    "name": "Cosmos Hub",
    "shortName": "cosmos",
    "nativeCoinId": "cosmos",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "diode",
    "filePath": "network:diode",
    "chainId": 15,
    "caip2id": "eip155:15",
    "name": "Diode",
    "shortName": "diode",
    "nativeCoinId": "diode",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "milkomeda-c1",
    "filePath": "network:milkomeda-c1",
    "chainId": 2001,
    "caip2id": "eip155:2001",
    "name": "milkomeda C1",
    "shortName": "milkomeda",
    "nativeCoinId": "mADA",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "vanar",
    "filePath": "network:vanar",
    "chainId": 2040,
    "caip2id": "eip155:2040",
    "name": "Vanar",
    "shortName": "vanar",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "step",
    "filePath": "network:step",
    "chainId": 1234,
    "caip2id": "eip155:1234",
    "name": "step",
    "shortName": "step",
    "nativeCoinId": "step",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "polygon-zkevm",
    "filePath": "network:polygon-zkevm",
    "chainId": 1101,
    "caip2id": "eip155:1101",
    "name": "Polygon zkEVM",
    "shortName": "polygon",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "mantra",
    "filePath": "network:mantra",
    "name": "Mantra Chain",
    "shortName": "mantra",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "kujira",
    "filePath": "network:kujira",
    "caip2id": "cosmos:kaiyo-1",
    "name": "Kujira",
    "shortName": "kujira",
    "nativeCoinId": "kujira",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "aptos",
    "filePath": "network:aptos",
    "name": "Aptos",
    "shortName": "aptos",
    "nativeCoinId": "aptos",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "cosmos",
    "filePath": "network:cosmos",
    "name": "Cosmos",
    "shortName": "cosmos",
    "nativeCoinId": "cosmos",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "hemi",
    "filePath": "network:hemi",
    "chainId": 743111,
    "caip2id": "eip155:743111",
    "name": "Hemi",
    "shortName": "hemi",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "moonbase",
    "filePath": "network:moonbase",
    "chainId": 1287,
    "caip2id": "eip155:1287",
    "name": "moonbase",
    "shortName": "moonbase",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "eos",
    "filePath": "network:eos",
    "chainId": 17777,
    "caip2id": "eip155:17777",
    "name": "EOS evm",
    "shortName": "eos",
    "nativeCoinId": "eos",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "arweave",
    "filePath": "network:arweave",
    "name": "Arweave",
    "shortName": "arweave",
    "nativeCoinId": "ar",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "stellar",
    "filePath": "network:stellar",
    "caip2id": "stellar:pubnet",
    "name": "Stellar",
    "shortName": "stellar",
    "nativeCoinId": "stellar",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "zora",
    "filePath": "network:zora",
    "chainId": 7777777,
    "caip2id": "eip155:7777777",
    "name": "zora",
    "shortName": "zora",
    "nativeCoinId": "weth",
    "variants": [
      "background",
      "branded"
    ]
  },
  {
    "id": "cronos",
    "filePath": "network:cronos",
    "chainId": 25,
    "caip2id": "eip155:25",
    "name": "Cronos",
    "shortName": "CRO",
    "nativeCoinId": "crypto-com-chain",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "binance-smart-chain",
    "filePath": "network:binance-smart-chain",
    "chainId": 56,
    "caip2id": "eip155:56",
    "name": "BNB Smart Chain",
    "shortName": "BSC",
    "nativeCoinId": "binancecoin",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "elastos",
    "filePath": "network:elastos",
    "chainId": 20,
    "caip2id": "eip155:20",
    "name": "Elastos Smart Contract Chain",
    "shortName": "Elastos",
    "nativeCoinId": "elastos",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "xai",
    "filePath": "network:xai",
    "chainId": 660279,
    "caip2id": "eip155:660279",
    "name": "XAI",
    "shortName": "xai",
    "nativeCoinId": "xai-blockchain",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "iotex",
    "filePath": "network:iotex",
    "chainId": 4689,
    "caip2id": "eip155:4689",
    "name": "IoTeX",
    "shortName": "iotex",
    "nativeCoinId": "iotex",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "bouncebit",
    "filePath": "network:bouncebit",
    "chainId": 6001,
    "caip2id": "eip155:6001",
    "name": "BounceBit",
    "shortName": "bounce",
    "nativeCoinId": "bouncebit",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "beam",
    "filePath": "network:beam",
    "chainId": 4337,
    "caip2id": "eip155:4337",
    "name": "Beam",
    "shortName": "beam",
    "nativeCoinId": "beam",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "lukso",
    "filePath": "network:lukso",
    "chainId": 42,
    "caip2id": "eip155:42",
    "name": "Lukso",
    "shortName": "lukso",
    "nativeCoinId": "lukso-token-2",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "abstract",
    "filePath": "network:abstract",
    "chainId": 2741,
    "caip2id": "eip155:2741",
    "name": "Abstract",
    "shortName": "Abstract",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "abstract-sepolia",
    "filePath": "network:abstract",
    "chainId": 11124,
    "caip2id": "eip155:11124",
    "name": "Abstract Sepolia Testnet",
    "shortName": "Abstract Sepolia",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "astar",
    "filePath": "network:astar",
    "chainId": 592,
    "caip2id": "eip155:592",
    "name": "Astar",
    "shortName": "astar",
    "nativeCoinId": "astar",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "injective",
    "filePath": "network:injective",
    "name": "Injective",
    "shortName": "injective",
    "nativeCoinId": "injective-protocol",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "sonic",
    "filePath": "network:sonic",
    "chainId": 146,
    "caip2id": "eip155:146",
    "name": "Sonic",
    "shortName": "sonic",
    "nativeCoinId": "sonic",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "tron",
    "filePath": "network:tron",
    "name": "TRON",
    "shortName": "tron",
    "nativeCoinId": "tron",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "rootstock",
    "filePath": "network:rootstock",
    "chainId": 30,
    "caip2id": "eip155:30",
    "name": "Rootstock RSK",
    "shortName": "rootstock",
    "nativeCoinId": "rootstock",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "corn",
    "filePath": "network:corn",
    "chainId": 21000000,
    "caip2id": "eip155:21000000",
    "name": "Corn",
    "shortName": "corn",
    "nativeCoinId": "btc",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "harmony",
    "filePath": "network:harmony",
    "chainId": 1666600000,
    "caip2id": "eip155:1666600000",
    "name": "Harmony One",
    "shortName": "one",
    "nativeCoinId": "one",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "fantom",
    "filePath": "network:fantom",
    "chainId": 250,
    "caip2id": "eip155:250",
    "name": "Fantom Opera",
    "shortName": "fantom",
    "nativeCoinId": "fantom",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "clover",
    "filePath": "network:clover",
    "chainId": 1024,
    "caip2id": "eip155:1024",
    "name": "Clover",
    "shortName": "clover",
    "nativeCoinId": "clover-finance",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "xdc",
    "filePath": "network:xdc",
    "chainId": 50,
    "caip2id": "eip155:50",
    "name": "xdc network",
    "shortName": "xdc",
    "nativeCoinId": "xdc",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "velas",
    "filePath": "network:velas",
    "chainId": 106,
    "caip2id": "eip155:106",
    "name": "Velas",
    "shortName": "velas",
    "nativeCoinId": "velas",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "filecoin",
    "filePath": "network:filecoin",
    "chainId": 314,
    "caip2id": "eip155:314",
    "name": "Filecoin",
    "shortName": "filecoin",
    "nativeCoinId": "filecoin",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "chiliz",
    "filePath": "network:chiliz",
    "chainId": 88888,
    "caip2id": "eip155:88888",
    "name": "Chiliz",
    "shortName": "chiliz",
    "nativeCoinId": "chiliz",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "dogechain",
    "filePath": "network:dogechain",
    "chainId": 2000,
    "caip2id": "eip155:2000",
    "name": "Dogechain",
    "shortName": "dogechain",
    "nativeCoinId": "doge",
    "variants": [
      "background",
      "branded"
    ]
  },
  {
    "id": "lens",
    "filePath": "network:lens",
    "chainId": 37111,
    "caip2id": "eip155:37111",
    "name": "Lens",
    "shortName": "lens",
    "nativeCoinId": "GHO",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "mode",
    "filePath": "network:mode",
    "chainId": 34443,
    "caip2id": "eip155:34443",
    "name": "Mode",
    "shortName": "mode",
    "nativeCoinId": "mode",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "linea",
    "filePath": "network:linea",
    "chainId": 59144,
    "caip2id": "eip155:59144",
    "name": "Linea",
    "shortName": "linea",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "zeta-chain",
    "filePath": "network:zeta-chain",
    "chainId": 7000,
    "caip2id": "eip155:7000",
    "name": "Zeta Chain",
    "shortName": "zeta",
    "nativeCoinId": "zetachain",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "juno",
    "filePath": "network:juno",
    "name": "Juno",
    "shortName": "juno",
    "nativeCoinId": "juno-network",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "gravity",
    "filePath": "network:gravity",
    "chainId": 1625,
    "caip2id": "eip155:1625",
    "name": "gravity-network",
    "shortName": "gravity",
    "nativeCoinId": "g",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "avalanche",
    "filePath": "network:avalanche",
    "chainId": 43114,
    "caip2id": "eip155:43114",
    "name": "Avalanche C-Chain",
    "shortName": "Avalanche",
    "nativeCoinId": "avax",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "rollux",
    "filePath": "network:rollux",
    "chainId": 570,
    "caip2id": "eip155:570",
    "name": "Rollux",
    "shortName": "rollux",
    "nativeCoinId": "syscoin",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "lumia",
    "filePath": "network:lumia",
    "chainId": 994873017,
    "caip2id": "eip155:994873017",
    "name": "Lumia",
    "shortName": "lumia",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "mantle",
    "filePath": "network:mantle",
    "chainId": 5000,
    "caip2id": "eip155:5000",
    "name": "Mantle",
    "shortName": "mantle",
    "nativeCoinId": "mantle",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "bitcoin",
    "filePath": "network:bitcoin",
    "caip2id": "bip122:000000000019d6689c085ae165831e93",
    "name": "Bitcoin",
    "shortName": "bitcoin",
    "nativeCoinId": "bitcoin",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "litecoin",
    "filePath": "network:litecoin",
    "caip2id": "bip122:12a765e31ffd4059bada1e25190f6e98",
    "name": "Litecoin",
    "shortName": "ltc",
    "nativeCoinId": "litecoin",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "wemix",
    "filePath": "network:wemix",
    "chainId": 111,
    "caip2id": "eip155:1111",
    "name": "Wemix",
    "shortName": "wemix",
    "nativeCoinId": "wemix",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "bob",
    "filePath": "network:bob",
    "chainId": 60808,
    "caip2id": "eip155:60808",
    "name": "Bob",
    "shortName": "bob",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "botanix",
    "filePath": "network:botanix",
    "chainId": 3637,
    "caip2id": "eip155:3637",
    "name": "Botanix",
    "shortName": "botanix",
    "nativeCoinId": "btc",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "sys",
    "filePath": "network:sys",
    "chainId": 57,
    "caip2id": "eip155:57",
    "name": "Syscoin",
    "shortName": "sys",
    "nativeCoinId": "sys",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "cardano",
    "filePath": "network:cardano",
    "caip2id": "cip-34:1-764824073",
    "name": "Cardano",
    "shortName": "ada",
    "nativeCoinId": "cardano",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "treasure",
    "filePath": "network:treasure",
    "chainId": 61166,
    "caip2id": "eip155:61166",
    "name": "Treasure",
    "shortName": "treasure",
    "nativeCoinId": "magic",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "shiden",
    "filePath": "network:shiden",
    "chainId": 336,
    "caip2id": "eip155:336",
    "name": "shiden",
    "shortName": "shiden",
    "nativeCoinId": "sdn",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "stargaze",
    "filePath": "network:stargaze",
    "name": "Stargaze",
    "shortName": "stargaze",
    "nativeCoinId": "stargaze",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "kardia",
    "filePath": "network:kardia",
    "chainId": 24,
    "caip2id": "eip155:24",
    "name": "kardia chain",
    "shortName": "kardia",
    "nativeCoinId": "kai",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "blast",
    "filePath": "network:blast",
    "chainId": 81457,
    "caip2id": "eip155:81457",
    "name": "Blast",
    "shortName": "blast",
    "nativeCoinId": "blast",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "etherlink",
    "filePath": "network:etherlink",
    "chainId": 42793,
    "caip2id": "eip155:42793",
    "name": "etherlink",
    "shortName": "etherlink",
    "nativeCoinId": "xtz",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "rari",
    "filePath": "network:rari",
    "chainId": 1380012617,
    "caip2id": "eip155:1380012617",
    "name": "Rari",
    "shortName": "rari",
    "nativeCoinId": "rari",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "unichain",
    "filePath": "network:unichain",
    "chainId": 130,
    "caip2id": "eip155:130",
    "name": "Unichain",
    "shortName": "uni",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "rei",
    "filePath": "network:rei",
    "chainId": 47805,
    "caip2id": "eip155:47805",
    "name": "Rei",
    "shortName": "rei",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "karura",
    "filePath": "network:karura",
    "chainId": 686,
    "caip2id": "eip155:686",
    "name": "Karura",
    "shortName": "karura",
    "nativeCoinId": "karura",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "world",
    "filePath": "network:world",
    "chainId": 480,
    "caip2id": "eip155:480",
    "name": "World Chain",
    "shortName": "world",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "sui",
    "filePath": "network:sui",
    "name": "Sui",
    "shortName": "sui",
    "nativeCoinId": "sui",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ronin",
    "filePath": "network:ronin",
    "chainId": 2020,
    "caip2id": "eip155:2020",
    "name": "Ronin",
    "shortName": "ron",
    "nativeCoinId": "ronin",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "bitkub-chain",
    "filePath": "network:bitkub-chain",
    "chainId": 96,
    "caip2id": "eip155:96",
    "name": "Bitkub Chain",
    "shortName": "bitkub",
    "nativeCoinId": "bitkub-coin",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "moonbase-alpha",
    "filePath": "network:moonbase-alpha",
    "chainId": 1287,
    "caip2id": "eip155:1287",
    "name": "Moonbase Alpha",
    "shortName": "Moonbase Alpha",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "nibiru",
    "filePath": "network:nibiru",
    "chainId": 6900,
    "caip2id": "eip155:6900",
    "name": "Nibiru",
    "nativeCoinId": "nibiru",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "gnosis",
    "filePath": "network:gnosis",
    "chainId": 100,
    "caip2id": "eip155:100",
    "name": "Gnosis Chain",
    "shortName": "xdai",
    "nativeCoinId": "xDai",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "xrp",
    "filePath": "network:xrp",
    "caip2id": "xrpl:0",
    "name": "XRP Ledger",
    "shortName": "xrp",
    "nativeCoinId": "ripple",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "lumio",
    "filePath": "network:lumio",
    "chainId": 8866,
    "caip2id": "eip155:8866",
    "name": "Super Lumio",
    "shortName": "lumio",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded"
    ]
  },
  {
    "id": "kakarot",
    "filePath": "network:kakarot",
    "name": "Kakarot",
    "shortName": "kakarot",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "x-layer",
    "filePath": "network:x-layer",
    "chainId": 196,
    "caip2id": "eip155:196",
    "name": "X Layer",
    "shortName": "xlayer",
    "nativeCoinId": "okb",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "energy-web",
    "filePath": "network:energy-web",
    "chainId": 246,
    "caip2id": "eip155:246",
    "name": "energy web",
    "shortName": "energy",
    "nativeCoinId": "ewt",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "metis-andromeda",
    "filePath": "network:metis-andromeda",
    "chainId": 1088,
    "caip2id": "eip155:1088",
    "name": "Metis Andromeda",
    "shortName": "metis",
    "nativeCoinId": "metis-token",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "coinex-smart-chain",
    "filePath": "network:coinex-smart-chain",
    "chainId": 52,
    "caip2id": "eip155:52",
    "name": "CoinEx Smart Chain",
    "shortName": "CSC",
    "nativeCoinId": "coinex-token",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "hedera-hashgraph",
    "filePath": "network:hedera-hashgraph",
    "chainId": 295,
    "caip2id": "eip155:295",
    "name": "Hedera Hashgraph",
    "shortName": "hedera",
    "nativeCoinId": "hedera-hashgraph",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "tenet",
    "filePath": "network:tenet",
    "chainId": 1559,
    "caip2id": "eip155:1559",
    "name": "Tenet",
    "shortName": "tenet",
    "nativeCoinId": "tenet-1b000f7b-59cb-4e06-89ce-d62b32d362b9",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "arbitrum-one",
    "filePath": "network:arbitrum-one",
    "chainId": 42161,
    "caip2id": "eip155:42161",
    "name": "Arbitrum One",
    "shortName": "Arbitrum",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "scroll",
    "filePath": "network:scroll",
    "chainId": 534352,
    "caip2id": "eip155:534352",
    "name": "Scroll",
    "shortName": "scroll",
    "nativeCoinId": "weth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "boba",
    "filePath": "network:boba",
    "chainId": 288,
    "caip2id": "eip155:288",
    "name": "Boba Network",
    "shortName": "boba",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "viction",
    "filePath": "network:viction",
    "chainId": 88,
    "caip2id": "eip155:88",
    "name": "Viction",
    "shortName": "viction",
    "nativeCoinId": "viction",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "monad",
    "filePath": "network:monad",
    "chainId": 143,
    "caip2id": "eip155:143",
    "name": "Monad",
    "shortName": "monad",
    "nativeCoinId": "monad",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "immutable",
    "filePath": "network:immutable",
    "chainId": 13371,
    "caip2id": "eip155:13371",
    "name": "Immutable zkEVM",
    "shortName": "immutable",
    "nativeCoinId": "immutable-x",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "flare",
    "filePath": "network:flare",
    "chainId": 14,
    "caip2id": "eip155:14",
    "name": "flare",
    "shortName": "flare",
    "nativeCoinId": "flr",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "wax",
    "filePath": "network:wax",
    "caip2id": "antelope:1064487b3cd1a897ce03ae5b6a865651",
    "name": "WAX",
    "shortName": "wax",
    "nativeCoinId": "wax",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "taiko",
    "filePath": "network:taiko",
    "chainId": 167000,
    "caip2id": "eip155:167000",
    "name": "Taiko",
    "shortName": "taiko",
    "nativeCoinId": "taiko",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "lyra",
    "filePath": "network:lyra",
    "chainId": 957,
    "caip2id": "eip155:957",
    "name": "lyra chain",
    "shortName": "lyra",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "starknet",
    "filePath": "network:starknet",
    "name": "StarkNet",
    "shortName": "starknet",
    "nativeCoinId": "starknet",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "moonbeam",
    "filePath": "network:moonbeam",
    "chainId": 1284,
    "caip2id": "eip155:1284",
    "name": "Moonbeam",
    "shortName": "moonbeam",
    "nativeCoinId": "moonbeam",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "super-seed",
    "filePath": "network:super-seed",
    "chainId": 5330,
    "caip2id": "eip155:5330",
    "name": "Super Seed",
    "shortName": "Super Seed",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "fluence",
    "filePath": "network:fluence",
    "chainId": 9999999,
    "caip2id": "eip155:9999999",
    "name": "Fluence",
    "shortName": "fluence",
    "nativeCoinId": "flt",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "orderly",
    "filePath": "network:orderly",
    "chainId": 291,
    "caip2id": "eip155:291",
    "name": "Orderly",
    "shortName": "orderly",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "okex",
    "filePath": "network:okex",
    "chainId": 66,
    "caip2id": "eip155:66",
    "name": "OKEx Chain",
    "shortName": "OKEx",
    "nativeCoinId": "okex",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "kroma",
    "filePath": "network:kroma",
    "chainId": 255,
    "caip2id": "eip155:255",
    "name": "kroma",
    "shortName": "kroma",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "kava",
    "filePath": "network:kava",
    "chainId": 2222,
    "caip2id": "cosmos:kava-4",
    "name": "Kava",
    "shortName": "kava",
    "nativeCoinId": "kava",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "moonriver",
    "filePath": "network:moonriver",
    "chainId": 1285,
    "caip2id": "eip155:1285",
    "name": "Moonriver",
    "shortName": "moonriver",
    "nativeCoinId": "moonriver",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ubiq",
    "filePath": "network:ubiq",
    "chainId": 8,
    "caip2id": "eip155:8",
    "name": "ubiq",
    "shortName": "ubiq",
    "nativeCoinId": "ubq",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "soneium",
    "filePath": "network:soneium",
    "chainId": 1868,
    "caip2id": "eip155:1868",
    "name": "Soneium",
    "shortName": "soneium",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "nahmii",
    "filePath": "network:nahmii",
    "chainId": 4061,
    "caip2id": "eip155:4061",
    "name": "Nahmii",
    "shortName": "nahmii",
    "nativeCoinId": "nahmii",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "lightlink",
    "filePath": "network:lightlink",
    "chainId": 1890,
    "caip2id": "eip155:1890",
    "name": "LightLink",
    "shortName": "lightlink",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "lisk",
    "filePath": "network:lisk",
    "chainId": 1135,
    "caip2id": "eip155:1135",
    "name": "Lisk",
    "shortName": "lisk",
    "nativeCoinId": "lisk",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "push",
    "filePath": "network:push",
    "name": "Push Chain",
    "shortName": "Push",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "polkadot",
    "filePath": "network:polkadot",
    "caip2id": "polkadot:91b171bb158e2d3848fa23a9f1c25182",
    "name": "Polkadot",
    "shortName": "dot",
    "nativeCoinId": "polkadot",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "oasys",
    "filePath": "network:oasys",
    "chainId": 248,
    "caip2id": "eip155:248",
    "name": "Oasys",
    "shortName": "oasys",
    "nativeCoinId": "oasys",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "base",
    "filePath": "network:base",
    "chainId": 8453,
    "caip2id": "eip155:8453",
    "name": "Base",
    "shortName": "base",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "optimism",
    "filePath": "network:optimism",
    "chainId": 10,
    "caip2id": "eip155:10",
    "name": "Optimism",
    "shortName": "Optimism",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "loopring",
    "filePath": "network:loopring",
    "name": "Loopring",
    "shortName": "loopring",
    "nativeCoinId": "loopring",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "osmosis",
    "filePath": "network:osmosis",
    "name": "Osmosis",
    "shortName": "Osmo",
    "nativeCoinId": "osmosis",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ultron",
    "filePath": "network:ultron",
    "chainId": 1231,
    "caip2id": "eip155:1231",
    "name": "Ultron",
    "shortName": "ultron",
    "nativeCoinId": "ultron",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "songbird",
    "filePath": "network:songbird",
    "chainId": 19,
    "caip2id": "eip155:19",
    "name": "Songbird",
    "shortName": "19",
    "nativeCoinId": "songbird",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "hubble-exchange",
    "filePath": "network:hubble-exchange",
    "chainId": 1992,
    "caip2id": "eip155:1992",
    "name": "hubble exchange",
    "shortName": "hubble",
    "nativeCoinId": "usdc",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "kucoin",
    "filePath": "network:kucoin",
    "name": "kucoin",
    "shortName": "kucoin",
    "nativeCoinId": "kcs",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "manta-pacific",
    "filePath": "network:manta-pacific",
    "chainId": 169,
    "name": "Manta Pacific",
    "shortName": "manta",
    "nativeCoinId": "weth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ethereum-classic",
    "filePath": "network:ethereum-classic",
    "chainId": 61,
    "caip2id": "eip155:61",
    "name": "Ethereum Classic",
    "shortName": "eth-classic",
    "nativeCoinId": "ethereum-classic",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "acala",
    "filePath": "network:acala",
    "chainId": 787,
    "caip2id": "eip155:787",
    "name": "Acala",
    "shortName": "acala",
    "nativeCoinId": "acala",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "neo-x",
    "filePath": "network:neo-x",
    "chainId": 47763,
    "caip2id": "eip155:47763",
    "name": "neo-x",
    "shortName": "neox",
    "nativeCoinId": "neo",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "silicon",
    "filePath": "network:silicon",
    "chainId": 2355,
    "caip2id": "eip155:2355",
    "name": "Silicon zkEVM",
    "shortName": "silicon",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "sei-network",
    "filePath": "network:sei-network",
    "chainId": 1329,
    "caip2id": "eip155:1329",
    "name": "Sei Network",
    "shortName": "sei",
    "nativeCoinId": "sei-network",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "milkomeda-a1",
    "filePath": "network:milkomeda-a1",
    "chainId": 2002,
    "caip2id": "eip155:2002",
    "name": "milkomeda A1",
    "shortName": "milkomeda",
    "nativeCoinId": "mALGO",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "shimmer-evm",
    "filePath": "network:shimmer-evm",
    "chainId": 148,
    "caip2id": "eip155:148",
    "name": "shimmer evm",
    "shortName": "shimmer",
    "nativeCoinId": "smr",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "telos",
    "filePath": "network:telos",
    "chainId": 40,
    "caip2id": "eip155:40",
    "name": "Telos",
    "shortName": "telos",
    "nativeCoinId": "telos",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "lycan",
    "filePath": "network:lycan",
    "chainId": 721,
    "caip2id": "eip155:721",
    "name": "Lycan",
    "shortName": "lycan",
    "nativeCoinId": "lyc",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "celo",
    "filePath": "network:celo",
    "chainId": 42220,
    "caip2id": "eip155:42220",
    "name": "Celo",
    "shortName": "celo",
    "nativeCoinId": "celo",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "zilliqa",
    "filePath": "network:zilliqa",
    "chainId": 32769,
    "caip2id": "eip155:32769",
    "name": "Zilliqa",
    "shortName": "zilliqa",
    "nativeCoinId": "zilliqa",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "reya",
    "filePath": "network:reya",
    "chainId": 1729,
    "caip2id": "eip155:1729",
    "name": "reya",
    "shortName": "reya",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "edgeless",
    "filePath": "network:edgeless",
    "chainId": 2026,
    "caip2id": "eip155:2026",
    "name": "Edgeless Network",
    "shortName": "edgeless",
    "nativeCoinId": "eweth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "kaia",
    "filePath": "network:kaia",
    "chainId": 8217,
    "caip2id": "eip155:8217",
    "name": "Kaia",
    "shortName": "kaia",
    "nativeCoinId": "kaia",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "conflux",
    "filePath": "network:conflux",
    "chainId": 1030,
    "caip2id": "eip155:1030",
    "name": "Conflux",
    "shortName": "conflux",
    "nativeCoinId": "conflux-token",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "solana",
    "filePath": "network:solana",
    "caip2id": "solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
    "name": "Solana",
    "shortName": "Solana",
    "nativeCoinId": "solana",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "optopia",
    "filePath": "network:optopia",
    "chainId": 62050,
    "caip2id": "eip155:62050",
    "name": "Optopia AI",
    "shortName": "optopia",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "arbitrum-nova",
    "filePath": "network:arbitrum-nova",
    "chainId": 42170,
    "caip2id": "eip155:42170",
    "name": "Arbitrum Nova",
    "shortName": "arbitrum-nova",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "fio",
    "filePath": "network:fio",
    "name": "FIO Protocol",
    "shortName": "fio",
    "nativeCoinId": "FIO",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "algorand",
    "filePath": "network:algorand",
    "caip2id": "algorand:wGHE2Pwdvd7S12BL5FaOP20EGYesN73k",
    "name": "Algorand",
    "shortName": "algo",
    "nativeCoinId": "algorand",
    "variants": [
      "mono",
      "background",
      "branded"
    ]
  },
  {
    "id": "berachain",
    "filePath": "network:berachain",
    "chainId": 80094,
    "caip2id": "eip155:80094",
    "name": "Berachain",
    "shortName": "berachain",
    "nativeCoinId": "BERA",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "paradex",
    "filePath": "network:paradex",
    "name": "Paradex",
    "shortName": "paradex",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "zero-network",
    "filePath": "network:zero-network",
    "chainId": 543210,
    "caip2id": "eip155:543210",
    "name": "Zero Network",
    "shortName": "zero-network",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "zircuit",
    "filePath": "network:zircuit",
    "chainId": 48900,
    "caip2id": "eip155:48900",
    "name": "Zircuit",
    "shortName": "zircuit",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "expchain",
    "filePath": "network:expchain",
    "chainId": 18880,
    "caip2id": "eip155:18880",
    "name": "EXPchain",
    "shortName": "expchain",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "japan-open-chain",
    "filePath": "network:japan-open-chain",
    "chainId": 81,
    "caip2id": "eip155:81",
    "name": "Japan Open Chain",
    "shortName": "JOC",
    "nativeCoinId": "JOC",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "vana",
    "filePath": "network:vana",
    "chainId": 1480,
    "caip2id": "eip155:1480",
    "name": "Vana",
    "shortName": "vana",
    "nativeCoinId": "VANA",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "vara",
    "filePath": "network:vara",
    "caip2id": "gear:vara-mainnet",
    "name": "Vara",
    "shortName": "vara",
    "nativeCoinId": "VARA",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "iota-evm",
    "filePath": "network:iota-evm",
    "chainId": 8822,
    "caip2id": "eip155:8822",
    "name": "Iota EVM",
    "shortName": "Iota",
    "nativeCoinId": "IOTA",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "apechain",
    "filePath": "network:apechain",
    "chainId": 33139,
    "caip2id": "eip155:33139",
    "name": "Apechain",
    "shortName": "Ape",
    "nativeCoinId": "APE",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "nexis",
    "filePath": "network:nexis",
    "chainId": 2370,
    "caip2id": "eip155:2370",
    "name": "Nexis Network",
    "shortName": "Nexis",
    "nativeCoinId": "NZT",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ink",
    "filePath": "network:ink",
    "chainId": 57073,
    "caip2id": "eip155:57073",
    "name": "Ink",
    "shortName": "Ink",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ontology",
    "filePath": "network:ontology",
    "chainId": 58,
    "caip2id": "eip155:58",
    "name": "Ontology",
    "shortName": "Ontology",
    "nativeCoinId": "ONG",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "prom",
    "filePath": "network:prom",
    "chainId": 227,
    "caip2id": "eip155:227",
    "name": "Prom",
    "shortName": "Prom",
    "nativeCoinId": "PROM",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "autonomys",
    "filePath": "network:autonomys",
    "chainId": 490000,
    "caip2id": "eip155:490000",
    "name": "Autonomys EVM",
    "shortName": "Auto EVM",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "swell",
    "filePath": "network:swell",
    "chainId": 1923,
    "caip2id": "eip155:1923",
    "name": "Swell Network",
    "shortName": "Swell",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "hashkey",
    "filePath": "network:hashkey",
    "chainId": 177,
    "caip2id": "eip155:177",
    "name": "Hashkey Chain",
    "shortName": "Hashkey",
    "nativeCoinId": "HSK",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "peaq",
    "filePath": "network:peaq",
    "chainId": 3338,
    "caip2id": "eip155:3338",
    "name": "peaq",
    "shortName": "peaq",
    "nativeCoinId": "PEAQ",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "mega-eth",
    "filePath": "network:mega-eth",
    "chainId": 6342,
    "caip2id": "eip155:6342",
    "name": "Mega ETH",
    "shortName": "Mega",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ultra",
    "filePath": "network:ultra",
    "caip2id": "antelope:a9c481dfbc7d9506dc7e87e9a137c931",
    "name": "Ultra",
    "shortName": "Ultra",
    "nativeCoinId": "UOS",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "katana",
    "filePath": "network:katana",
    "chainId": 129399,
    "caip2id": "eip155:129399",
    "name": "Katana",
    "shortName": "katana",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ozean",
    "filePath": "network:ozean",
    "chainId": 31911,
    "caip2id": "eip155:31911",
    "name": "Ozean",
    "shortName": "ozean",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "status",
    "filePath": "network:status",
    "chainId": 1660990954,
    "caip2id": "eip155:1660990954",
    "name": "Status",
    "shortName": "status",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "vaulta",
    "filePath": "network:vaulta",
    "chainId": 17777,
    "caip2id": "eip155:17777",
    "name": "Vaulta EVM",
    "shortName": "Vaulta",
    "nativeCoinId": "EOS",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "stacks",
    "filePath": "network:stacks",
    "caip2id": "stacks:1",
    "name": "Stacks",
    "shortName": "stacks",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "supra-movevm",
    "filePath": "network:supra-movevm",
    "name": "Supra MoveVM",
    "shortName": "Supra",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "movement",
    "filePath": "network:movement",
    "name": "Movement",
    "shortName": "movement",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "fuel",
    "filePath": "network:fuel",
    "chainId": 9889,
    "caip2id": "eip155:9889",
    "name": "Fuel",
    "shortName": "fuel",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "sepolia",
    "filePath": "network:ethereum",
    "chainId": 11155111,
    "caip2id": "eip155:11155111",
    "name": "Sepolia Testnet",
    "shortName": "Sepolia",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "binance-smart-chain-testnet",
    "filePath": "network:binance-smart-chain",
    "chainId": 97,
    "caip2id": "eip155:97",
    "name": "BNB Smart Chain Testnet",
    "shortName": "BSC Testnet",
    "nativeCoinId": "binancecoin",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "polygon-amoy",
    "filePath": "network:polygon",
    "chainId": 80002,
    "caip2id": "eip155:80002",
    "name": "Polygon Amoy Testnet",
    "shortName": "Amoy",
    "nativeCoinId": "matic-network",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "polygon-zkevm-cardona",
    "filePath": "network:polygon-zkevm",
    "chainId": 2442,
    "caip2id": "eip155:2442",
    "name": "Polygon zkEVM Cardona Testnet",
    "shortName": "zkEVM Cardona",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "avalanche-fuji",
    "filePath": "network:avalanche",
    "chainId": 43113,
    "caip2id": "eip155:43113",
    "name": "Avalanche Fuji Testnet",
    "shortName": "Fuji",
    "nativeCoinId": "avax",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "arbitrum-sepolia",
    "filePath": "network:arbitrum-one",
    "chainId": 421614,
    "caip2id": "eip155:421614",
    "name": "Arbitrum Sepolia Testnet",
    "shortName": "Arbitrum Sepolia",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "optimism-sepolia",
    "filePath": "network:optimism",
    "chainId": 11155420,
    "caip2id": "eip155:11155420",
    "name": "OP Sepolia Testnet",
    "shortName": "OP Sepolia",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "base-sepolia",
    "filePath": "network:base",
    "chainId": 84532,
    "caip2id": "eip155:84532",
    "name": "Base Sepolia Testnet",
    "shortName": "Base Sepolia",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "zksync-sepolia",
    "filePath": "network:zksync",
    "chainId": 300,
    "caip2id": "eip155:300",
    "name": "zkSync Sepolia Testnet",
    "shortName": "zkSync Sepolia",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "scroll-sepolia",
    "filePath": "network:scroll",
    "chainId": 534351,
    "caip2id": "eip155:534351",
    "name": "Scroll Sepolia Testnet",
    "shortName": "Scroll Sepolia",
    "nativeCoinId": "weth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "linea-sepolia",
    "filePath": "network:linea",
    "chainId": 59141,
    "caip2id": "eip155:59141",
    "name": "Linea Sepolia Testnet",
    "shortName": "Linea Sepolia",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "fantom-testnet",
    "filePath": "network:fantom",
    "chainId": 4002,
    "caip2id": "eip155:4002",
    "name": "Fantom Testnet",
    "shortName": "Fantom Testnet",
    "nativeCoinId": "fantom",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "celo-alfajores",
    "filePath": "network:celo",
    "chainId": 44787,
    "caip2id": "eip155:44787",
    "name": "Celo Alfajores Testnet",
    "shortName": "Alfajores",
    "nativeCoinId": "celo",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "mantle-sepolia",
    "filePath": "network:mantle",
    "chainId": 5003,
    "caip2id": "eip155:5003",
    "name": "Mantle Sepolia Testnet",
    "shortName": "Mantle Sepolia",
    "nativeCoinId": "mantle",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "blast-sepolia",
    "filePath": "network:blast",
    "chainId": 168587773,
    "caip2id": "eip155:168587773",
    "name": "Blast Sepolia Testnet",
    "shortName": "Blast Sepolia",
    "nativeCoinId": "blast",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "taiko-hekla",
    "filePath": "network:taiko",
    "chainId": 167009,
    "caip2id": "eip155:167009",
    "name": "Taiko Hekla Testnet",
    "shortName": "Hekla",
    "nativeCoinId": "eth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "mode-sepolia",
    "filePath": "network:mode",
    "chainId": 919,
    "caip2id": "eip155:919",
    "name": "Mode Sepolia Testnet",
    "shortName": "Mode Sepolia",
    "nativeCoinId": "mode",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "zetachain-testnet",
    "filePath": "network:zeta-chain",
    "chainId": 7001,
    "caip2id": "eip155:7001",
    "name": "ZetaChain Testnet",
    "shortName": "ZetaChain Testnet",
    "nativeCoinId": "zetachain",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "kaia-kairos",
    "filePath": "network:kaia",
    "chainId": 1001,
    "caip2id": "eip155:1001",
    "name": "Kaia Kairos Testnet",
    "shortName": "Kairos",
    "nativeCoinId": "kaia",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "filecoin-calibration",
    "filePath": "network:filecoin",
    "chainId": 314159,
    "caip2id": "eip155:314159",
    "name": "Filecoin Calibration Testnet",
    "shortName": "Filecoin Calibration",
    "nativeCoinId": "filecoin",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "manta-pacific-sepolia",
    "filePath": "network:manta-pacific",
    "chainId": 3441006,
    "caip2id": "eip155:3441006",
    "name": "Manta Pacific Sepolia Testnet",
    "shortName": "Manta Sepolia",
    "nativeCoinId": "weth",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "metis-sepolia",
    "filePath": "network:metis-andromeda",
    "chainId": 59902,
    "caip2id": "eip155:59902",
    "name": "Metis Sepolia Testnet",
    "shortName": "Metis Sepolia",
    "nativeCoinId": "metis-token",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "boba-sepolia",
    "filePath": "network:boba",
    "chainId": 28882,
    "caip2id": "eip155:28882",
    "name": "Boba Sepolia Testnet",
    "shortName": "Boba Sepolia",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "cronos-testnet",
    "filePath": "network:cronos",
    "chainId": 338,
    "caip2id": "eip155:338",
    "name": "Cronos Testnet",
    "shortName": "Cronos Testnet",
    "nativeCoinId": "crypto-com-chain",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "kava-testnet",
    "filePath": "network:kava",
    "chainId": 2221,
    "caip2id": "eip155:2221",
    "name": "Kava Testnet",
    "shortName": "Kava Testnet",
    "nativeCoinId": "kava",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "telos-testnet",
    "filePath": "network:telos",
    "chainId": 41,
    "caip2id": "eip155:41",
    "name": "Telos EVM Testnet",
    "shortName": "Telos Testnet",
    "nativeCoinId": "telos",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ethereum-classic-mordor",
    "filePath": "network:ethereum-classic",
    "chainId": 63,
    "caip2id": "eip155:63",
    "name": "Ethereum Classic Mordor Testnet",
    "shortName": "ETC Mordor",
    "nativeCoinId": "ethereum-classic",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "arc",
    "filePath": "network:arc",
    "chainId": 5042002,
    "caip2id": "eip155:5042002",
    "name": "Arc",
    "shortName": "Arc",
    "nativeCoinId": "USDC",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "shibarium",
    "filePath": "token:SHIB",
    "chainId": 109,
    "caip2id": "eip155:109",
    "name": "Shibarium",
    "shortName": "Shibarium",
    "nativeCoinId": "BONE",
    "variants": [
      "branded",
      "background"
    ]
  },
  {
    "id": "minima",
    "filePath": "network:minima",
    "name": "Minima",
    "shortName": "Minima",
    "nativeCoinId": "MINIMA",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ame-chain",
    "filePath": "network:ame-chain",
    "chainId": 180,
    "caip2id": "eip155:180",
    "name": "Ame Chain",
    "shortName": "Ame",
    "nativeCoinId": "AME",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "bahamut",
    "filePath": "network:bahamut",
    "chainId": 5165,
    "caip2id": "eip155:5165",
    "name": "Bahamut",
    "shortName": "Bahamut",
    "nativeCoinId": "FTN",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "hyper-evm",
    "filePath": "network:hyper-evm",
    "chainId": 999,
    "caip2id": "eip155:999",
    "name": "Hyper EVM",
    "shortName": "Hyper",
    "nativeCoinId": "HYPE",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "symbiosis",
    "filePath": "network:symbiosis",
    "chainId": 13863860,
    "caip2id": "eip155:13863860",
    "name": "Symbiosis",
    "shortName": "Symbiosis",
    "nativeCoinId": "SIS",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "gunz",
    "filePath": "network:gunz",
    "chainId": 43419,
    "caip2id": "eip155:43419",
    "name": "GUNZ",
    "shortName": "GUNZ",
    "nativeCoinId": "GUN",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "flow",
    "filePath": "token:FLOW",
    "chainId": 747,
    "caip2id": "eip155:747",
    "name": "Flow",
    "shortName": "Flow",
    "nativeCoinId": "FLOW",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "flow-testnet",
    "filePath": "token:FLOW",
    "chainId": 545,
    "caip2id": "eip155:545",
    "name": "Flow Testnet",
    "shortName": "Flow",
    "nativeCoinId": "FLOW",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "stable",
    "filePath": "network:stable",
    "chainId": 988,
    "caip2id": "eip155:988",
    "name": "Stablechain",
    "shortName": "Stable",
    "nativeCoinId": "USDT",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "juris",
    "filePath": "network:juris",
    "name": "Juris Protocol",
    "shortName": "Juris",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "terra-classic",
    "filePath": "network:terra-classic",
    "name": "Terra Classic",
    "shortName": "Terra",
    "nativeCoinId": "LUNC",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "xdc-network",
    "filePath": "token:XDC",
    "chainId": 51,
    "caip2id": "eip155:51",
    "name": "XDC Network",
    "shortName": "XDC",
    "nativeCoinId": "XDC",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "crab",
    "filePath": "network:crab",
    "chainId": 44,
    "caip2id": "eip155:44",
    "name": "Crab",
    "shortName": "Crab",
    "nativeCoinId": "CRAB",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "darwinia",
    "filePath": "network:darwinia",
    "chainId": 46,
    "caip2id": "eip155:46",
    "name": "Darwinia",
    "shortName": "Darwinia",
    "nativeCoinId": "RING",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "genesis-l1",
    "filePath": "network:genesis-l1",
    "chainId": 29,
    "caip2id": "eip155:29",
    "name": "Genesis L1",
    "shortName": "Genesis L1",
    "nativeCoinId": "L1",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "tempo",
    "filePath": "network:tempo",
    "name": "Tempo",
    "shortName": "Tempo",
    "nativeCoinId": "USD",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "uptick",
    "filePath": "network:uptick",
    "chainId": 117,
    "caip2id": "eip155:117",
    "name": "Uptick",
    "shortName": "Uptick",
    "nativeCoinId": "UPTICK",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "plasma",
    "filePath": "network:plasma",
    "chainId": 9745,
    "caip2id": "eip155:9745",
    "name": "Plasma",
    "shortName": "Plasma",
    "nativeCoinId": "XPL",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "ton",
    "filePath": "network:ton",
    "chainId": -239,
    "caip2id": "ton:-239",
    "name": "The Open Network",
    "shortName": "TON",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "plume",
    "filePath": "network:plume",
    "chainId": 98866,
    "caip2id": "eip155:98866",
    "name": "Plume",
    "shortName": "Plume",
    "nativeCoinId": "PLUME",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "codex",
    "filePath": "network:codex",
    "chainId": 81224,
    "caip2id": "eip155:81224",
    "name": "Codex",
    "shortName": "Codex",
    "nativeCoinId": "ETH",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "pulsechain",
    "filePath": "network:pulsechain",
    "chainId": 369,
    "caip2id": "eip155:369",
    "name": "Pulsechain",
    "shortName": "PLS",
    "nativeCoinId": "PLS",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "monad-testnet",
    "filePath": "network:monad",
    "chainId": 10143,
    "caip2id": "eip155:10143",
    "name": "Monad Testnet",
    "shortName": "Monad Testnet",
    "nativeCoinId": "MON",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "citrea",
    "filePath": "network:citrea",
    "chainId": 4114,
    "caip2id": "eip155:4114",
    "name": "Citrea",
    "shortName": "Citrea",
    "nativeCoinId": "CBTC",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  }
]